import styled from 'styled-components';

import { cFFFFFF } from '#/colors';

import {
  useNotificationsDrawerActions,
  useNotificationsDrawerView,
} from '#/features/notifications/drawer-context';
import SettingsIcon from '#/assets/SettingsIcon';

export default function NotificationsDrawerActions() {
  const drawerView = useNotificationsDrawerView();
  const drawerActions = useNotificationsDrawerActions();

  return (
    <Container>
      <SettingsButton
        isActive={drawerView.isSettingsMenuOpen}
        onClick={drawerActions.toggleSettingsMenu}
      />
    </Container>
  );
}

const Container = styled.div`
  height: 100%;
  display: flex;
  gap: 12px;
  padding-top: 3px;
`;

interface SettingsButtonProps {
  isActive: boolean;
}

const SettingsButton = styled.button.attrs({
  'aria-label': 'Notifications Settings',
  children: <SettingsIcon />,
})<SettingsButtonProps>`
  height: 100%;
  display: grid;
  place-items: center;
  padding: 0;
  background: none;
  border: none;
  color: ${cFFFFFF};
  opacity: ${({ isActive }) => (isActive ? '0.7' : '0.5')};

  &:hover {
    opacity: 0.7;
  }
`;
